import parent from '../path';

export default `${parent}/products`;
